import {
  loadStripe,
} from '@stripe/stripe-js';
export const STRIPE_PUBLISHABLE_KEY: string = import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY;
export const stripePromise = loadStripe(STRIPE_PUBLISHABLE_KEY);
